// Slider Slick launcher
// Created: 06/2016
// Updated: 29 septembre 2016 // Refactoring you may have forgotten and bought with
// Created for: You might like(Shopping list)
// Also used for you may have forgotten( my cart ) and bought With( product detail )
function ymlcSlider(slider, itemsPerPage, filter) {

    var sliderText = {
        prev: 'Précédent',
        next: 'Suivant'
    };

    if (lang === 'en') {
        sliderText = {
            prev: 'Previous',
            next: 'Next'
        }
    }

    var launch_slider = function () {
        var slider_width = slider.width(),
            slides = slider.find('> *:not(.hide)'),
            slides_width = 0,
            slides_total = slides.length,
            center = false;

        // Si le slider :
        //                - n'est pas déjà initialisé
        //                - a plus d'une page d'item à afficher
        // on lance le plugin
        if (Revealizr.isDesktopSize && !slider.hasClass('slick-initialized') && slides_total > itemsPerPage) {
            slider.parent().addClass('has-slider');

            slider.slick({
                infinite: false,
                prevArrow: '<button class="slick-arrow slick-prev"><img src="/images/main/actions/toggle-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
                nextArrow: '<button class="slick-arrow slick-next"><img src="/images/main/actions/toggle-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',
                variableWidth: true,
                dots: true,
                customPaging: function (slider, i) {
                    return $('<button class="slider-dot" type="button" data-role="none" role="button" tabindex="0"><span class="invisible-text">Slide ' + i + '</span></button>');
                },
                appendDots: slider,
                centerMode: center,
                slidesToShow: itemsPerPage,
                slidesToScroll: itemsPerPage
            });

        } else if (!Revealizr.isDesktopSize && slider.hasClass('slick-initialized')) {
            unslick(slider);
        }
    };
    launch_slider();

    if(!!filter){
        slider.slick('slickFilter', filter);
    }

    $(window).on(Revealizr.resizeORorientation, _.throttle(launch_slider, 100));
}

function unslick(slider) {
    slider.parent().removeClass('has-slider');
    slider.slick('unslick');
}
